import { createSelector } from 'reselect'
import { RootStoreState } from '@src/models/app.types'

export const scansStoreSelector = (state: RootStoreState) => state.scans

export const scansMeasurementsSelector = createSelector(
  scansStoreSelector,
  (store) => store.measurements,
)
